<app-layout>
  <app-voltar route="listagem/carreta" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form">
      <div class="formList">
        <app-input
          type="text"
          label="Placa da Carreta"
          name="TX_PLCA_CRRT"
          [requiredInput]="true"
          formControlName="TX_PLCA_CRRT"
          mask="AAA-0A00"
          [disabled]="title.includes('Visualizar') ? true : false"
          placeholder="Digite aqui"></app-input>
      </div>
      <app-botao
        *ngIf="!disabledCarreta"
        type="cadastro"
        [text]="isEditing ? 'Editar Carreta' : 'Cadastrar Carreta'"
        class="botao-cadastro"
        (click)="postarDados()"
        [disabled]="!form.valid"></app-botao>
    </form>
  </div>

  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
